import { ListItem } from '@material-ui/core';
import Layout from '../../components/Layout';
import React, {useEffect, useState} from 'react'
import img from '../../asset/img.png';

import { BsSearch } from 'react-icons/bs';
import { getResolvedPath, useQuery } from '../../utils';
import { artService } from '../../services/artwork.service';
import { useNavigate, useParams } from 'react-router-dom';
import { safetyService } from '../../services/safety.service';
import {Button} from '@material-ui/core'
import { openSnackBar } from '../../redux/snackBarReducer';
import { useDispatch } from 'react-redux';
import ArtImageFallback from '../../components/ArtImageFallback';

export default () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const {artworkId} = useParams();
    const [artwork, setArtwork] = useState({});
    const [imgUrl, setImgUrl] = useState('');
    const [resultImgList, setResultImgList] = useState([]);
    const [update, setUpdate] = useState('');

    const init = async() => {
        const resp = await artService.getArtwork(artworkId);
        if (resp.status !== 'success' || !resp.artwork) return;

        const record = Array.isArray(resp.artwork) ? resp.artwork[0] : resp.artwork;
        const withArtist = {
            ...record,
            userDetails: resp.artist ? [resp.artist] : record.userDetails || [],
        };
        setArtwork(withArtist);
        if (record.images?.[0]) {
            setImgUrl(getResolvedPath(record.images[0]));
        }
    }

    const getOneSafetyInfoName = async() => {
        dispatch(openSnackBar({message: "Loading image searching result from the database", status: "info"}));
        const resp = await safetyService.getOneSafetyInfoName(artworkId);
        console.log(resp);
        if (resp.success){
            dispatch(openSnackBar({message: "loaded data from the database successfully", status: "success"}));
            setResultImgList(resp.oneSafetyTerm.imageList);
            console.log("imageResult:", resp.oneSafetyTerm.imageList);
            setUpdate(resp.oneSafetyTerm.updatedAt);
        } else {
            dispatch(openSnackBar({message: "There is no data for this artwork", status: "warning"}));
        }
    }

    
    const clickSearchBtn = async(value) => {
        
        dispatch(openSnackBar({message: "Loading image searching result", status: "info"}));
        const resp = await safetyService.sendSearchRequestByName(artworkId, value);
        setResultImgList(resp.oneSafetyTerm.imageList);
        setUpdate(resp.oneSafetyTerm.updatedAt);
        dispatch(openSnackBar({message:"Successfully loaded", status: "success"}));
        console.log(resultImgList);

    }
    

    useEffect(() => {
        init();
        getOneSafetyInfoName();
    }, [])
    

    return (
        <Layout>
            <div className='mt-10'>
                <div className='m-auto justify-between lg:flex'>
                    <div className='m-auto p-16 bg-gray-200 w-11/12 lg:flex'>
                        <ArtImageFallback
                          src={imgUrl}
                          alt={artwork.name || ''}
                          className="object-contain max-w-full max-h-full"
                          wrapperStyle={{ width: 400, height: 280, minHeight: 200 }}
                        />
                        <div className='leading-9 mt-4 lg:ml-16'>
                            <h2 className='text-lg text-red-600 my-2 font-bold'>{artwork.name || '—'}</h2>
                            <p className='text-lg font-bold'>{ artwork.userDetails?.length && (artwork.userDetails[0].firstname + " " + artwork.userDetails[0].lastname)}</p>
                            <p className='text-sm text-gray-500'>PRICE: {artwork.listed_price}</p>
                            <p className='text-sm text-gray-500'>Primary Colors : {artwork.colorlist?.map((item, key) => <span key = {key}>{item + " "}</span>)}</p>

                            <div className='flex mt-3 space-x-4'>

                                <Button  color="primary" variant="contained" onClick = {() => clickSearchBtn(artwork.name)}>
                                    <BsSearch /> &nbsp; Search By Names
                                </Button>
                                <Button variant="contained" onClick = {() => navigate('/')}>
                                     Back
                                </Button>
                                <Button  color="secondary" variant="contained" onClick = {() => navigate(`/artwork/url/${artworkId}`)}>
                                     Go to URL Search
                                </Button>
                            </div>

                            <p className='text-sm text-red-500 mt-2'>Updated Time : {update}</p>
                            <p className='text-lg text-blue-600 mt-4 font-bold'>About</p>
                            <div className='mt-2 leading-9'>
                                <p>Publication: {artwork.publication}</p>
                                <p>Description: {artwork.description}</p>
                                <p>Location: {artwork.location}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex m-auto bg-gray-200 mt-16 p-8 w-11/12'>
                    <ul className='m-auto w-11/12 h-[700px] overflow-auto'>
                       { 
                            resultImgList && resultImgList.map((item, key) => (
                                <li className='p-2' key = {key} ><ImgList item ={item} /></li>
                            ))
                       }
                    </ul>
                       {resultImgList.length == 0 ? <h1 className='text-red-400'>No Result</h1>:<h1>Results: {resultImgList.length}</h1>}
                </div>
            </div>
        </Layout>
    )
}

const ImgList = ({ item }) => {
    const thumb = item.imageUrl || item.thumbnailUrl;
    return (
        <div className='bg-white p-4 md:flex gap-4'>
            <ArtImageFallback
              src={thumb}
              alt=""
              className="object-cover max-w-full max-h-full"
              wrapperStyle={{ width: 150, height: 100, flexShrink: 0 }}
            />
            <div className='mt-2 sm:mt-0 min-w-0'>
                <a href={item.link} target="_blank" rel="noreferrer" className='block text-lg mb-2 break-all'>{item.link}</a>
                <p className='text-blue-600 mt-2 text-sm'>RESOLUTION: {item.thumbnailWidth || '—'} × {item.thumbnailHeight || '—'}</p>
            </div>
        </div>
    )
}